import { type CollectibleEventListRefined } from '@capsicum/common';
import { BaseTutorialCard, useTutorial, useTutorialStyles } from '@capsicum/common-web';
import { useEffect, useRef } from 'react';

export const useAuctionsTutorial = (events: Array<CollectibleEventListRefined>) => {
	const firstAuctionCardRef = useRef<HTMLDivElement>(null);

	const { highlightedAreaStyle } = useTutorialStyles();

	const { setup } = useTutorial();

	useEffect(() => {
		// halt the tutorial until the events are loaded
		if (events?.length === 0) return;

		if (firstAuctionCardRef.current) {
			setup('auctions', {
				steps: [
					{
						content: () => (
							<BaseTutorialCard
								content="rewards.auctions.tutorials.introduction.steps.first.content"
								title="rewards.auctions.tutorials.introduction.steps.first.title"
							/>
						),
						padding: 0,
						position: 'bottom',
						selector: firstAuctionCardRef?.current ?? '',
						stepInteraction: false,
						styles: {
							highlightedArea: highlightedAreaStyle({ disableInteraction: true })
						}
					}
				]
			});
		}
	}, [events?.length]);

	return {
		firstAuctionCardRef
	};
};
